import { useNavigate } from 'react-router-dom';
import api from '../lib/api';
import { PageHead, Section, Spinner, ErrorNote, Empty, useAsync } from '../components/ui';
import { CourseCardView } from '../components/cards';
import { unenrolledFirst } from '../lib/sort';
import '../styles/learn.css';

/**
 * Courses catalog (design/020). Full public Course library, one of the two
 * pages the retired /library page split into.
 */
export default function CoursesBrowsePage() {
  const navigate = useNavigate();
  const { loading, error, data, reload } = useAsync(
    () => api.learnLibrary().then((x) => (Array.isArray(x) ? x : [])),
    []
  );

  return (
    <div className="page">
      <PageHead icon="📚" title="Courses" sub="Browse and enroll in courses" />
      {loading ? <Spinner /> : error ? <ErrorNote error={error} onRetry={reload} /> : (
        <Section>
          {data.length === 0 ? <Empty>No courses published yet.</Empty> : (
            <div className="card-grid">
              {unenrolledFirst(data, 'enrolled').map((c) => (
                <CourseCardView key={c.id} c={c} onOpen={() => navigate(`/learn/course/${c.id}`)} />
              ))}
            </div>
          )}
        </Section>
      )}
    </div>
  );
}
